import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationRU from './locales/ru.json';
import translationEN from './locales/en.json';

// Отладка: проверяем что загрузилось
console.log('🔍 i18n DEBUG: translationRU keys:', Object.keys(translationRU).length);
console.log('🔍 i18n DEBUG: translationEN keys:', Object.keys(translationEN).length);
console.log('🔍 i18n DEBUG: translationRU.modals exists?', 'modals' in translationRU);

// Ресурсы переводов
const resources = {
  ru: {
    translation: translationRU
  },
  en: {
    translation: translationEN
  }
};

console.log('🔍 i18n DEBUG: resources:', resources);

// Языки СНГ → русский интерфейс, всё остальное → английский.
// language_code в Telegram — ISO 639-1 по основному языку клиента.
const CIS_LANGS = new Set([
  'ru', 'uk', 'be', 'kk', 'uz', 'ky', 'tg', 'tk', 'hy', 'az', 'ka', 'mo', 'ro'
]);

// СНГ → 'ru', остальные → 'en'
const normalizeLang = (langCode?: string | null): 'ru' | 'en' => {
  if (langCode && CIS_LANGS.has(langCode.toLowerCase().slice(0, 2))) {
    return 'ru';
  }
  return 'en';
};

// Функция для определения языка из Telegram
const getTelegramLanguage = (): string | undefined => {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp?.initDataUnsafe?.user) {
    const langCode = window.Telegram.WebApp.initDataUnsafe.user.language_code;
    // СНГ (ru/uk/kk/...) → русский, всё остальное → английский
    return normalizeLang(langCode);
  }
  return undefined;
};

// Кастомный детектор языка
const telegramLanguageDetector = {
  name: 'telegramLanguageDetector',
  lookup(): string | undefined {
    // Приоритет 1: localStorage (выбор пользователя)
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage === 'ru' || savedLanguage === 'en') {
      return savedLanguage;
    }

    // Приоритет 2: Telegram language_code
    const telegramLang = getTelegramLanguage();
    if (telegramLang) {
      // Сохраняем в localStorage для следующего раза
      localStorage.setItem('language', telegramLang);
      return telegramLang;
    }

    // Приоритет 3: Браузерный язык (СНГ → русский, остальное → английский)
    const browserLang = navigator.language.split('-')[0];
    return normalizeLang(browserLang);
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('language', lng);
  }
};

// Создаем экземпляр детектора и регистрируем кастомный детектор
const languageDetector = new LanguageDetector();
languageDetector.addDetector(telegramLanguageDetector);

// Инициализация i18next
i18n
  // Подключаем react-i18next
  .use(initReactI18next)
  // Подключаем детектор языка
  .use(languageDetector)
  // Инициализируем
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['ru', 'en'],

    // Настройки детектора
    detection: {
      order: ['telegramLanguageDetector', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language'
    },

    interpolation: {
      escapeValue: false // React уже защищает от XSS
    },

    react: {
      useSuspense: false // Отключаем Suspense для упрощения
    }
  });

// Дожидаемся инициализации
if (!i18n.isInitialized) {
  console.log('⏳ Waiting for i18n initialization...');
}

export default i18n;
